define('app/views/travel_pages_view',['app/setup'],
  function(takhfifan) {
    takhfifan.travelPages = Backbone.View.extend({

      initialize: function () {
        takhfifan.eventHub.on('travel:viewChanged', function (options) {
          this.changeView(options.view);
        }, this);

        if(takhfifan.travelInitRoute){
          if (takhfifan.travelInitRoute.callback){
            takhfifan.travelInitRoute.callback.apply(takhfifan.travelSearchRoute, takhfifan.travelInitRoute.args);
          }
          takhfifan.travelInitRoute = null;
        }
        takhfifan.travelSectionInited = true;

        takhfifan.eventHub.on('travel:disable', function () {
          this.disable();
        }, this);
        takhfifan.eventHub.on('travel:enable', function () {
          this.enable();
        }, this);

        this.enable();
      },

      changeView: function (view) {
        this.$('.tkh-travel-page-view').hide();
        this.$('.tkh-travel-page-view[data-view="'+view+'"]').show();
        this.changeTemplate(view);
      },

      disable:function(){
        this.$el.addClass('loading-view');
      },

      enable: function(){
        this.$el.removeClass('loading-view');
      },

      changeTemplate: function (view) {
        if(view==="cart" || view === "flight_confirm"){
          $('body').addClass('page-checkout-view');
        }else{
          $('body').removeClass('page-checkout-view');
        }
      }
    })
  });
